import * as Commons from "oc-commons/Commons";
import { UniversalLoader } from "oc-threejs/loader/UniversalLoader";
import * as Textures from "oc-threejs/Textures";
import { HDRCubeTextureLoader } from "three/examples/jsm/loaders/HDRCubeTextureLoader";
import { RGBMLoader } from "three/examples/jsm/loaders/RGBMLoader";
import { EXRLoader } from "three/examples/jsm/loaders/EXRLoader";
import { RGBELoader } from "three/examples/jsm/loaders/RGBELoader";
import { unflattenObject } from "oc-commons/Commons";
import { TextureLoader } from "oc-threejs/patched/TextureLoader.oc";
import {
  CubeReflectionMapping,
  CubeTextureLoader,
  DataTextureLoader,
  EquirectangularReflectionMapping,
  SRGBColorSpace,
} from "three";

export const envMapLoader = (urls: string[], renderer, isRGBM = false, onLoadExtern = () => {}) => {
  if (Commons.isEmpty(urls) || urls.some((url) => Commons.isEmpty(url))) {
    return null;
  }
  const isCube = !Commons.isEmpty(urls[1]);
  const getSuffix = (url) => url.split(/[?#]/g)[0].substringAfterLast(".");
  const { loadingManager, crossOrigin } = UniversalLoader;
  const onLoad = (texture, isCube, sourceFile) => {
    texture.anisotropy = Textures.getMaxAnisotropy();
    texture.colorSpace = SRGBColorSpace;
    texture.mapping = isCube ? CubeReflectionMapping : EquirectangularReflectionMapping;
    texture.sourceFile = sourceFile;
    // If you create an instance of DataTexture, DataTexture2DArray or DataTexture3D, you have to set needsUpdate to true as soon as the texture data are ready.
    texture.needsUpdate = true;
    onLoadExtern();
  };
  if (isCube) {
    const suffix = getSuffix(urls[0]);
    let loader;
    if (suffix == "hdr") {
      loader = new HDRCubeTextureLoader(loadingManager);
    } else if (isRGBM) {
      loader = new RGBMLoader(loadingManager);
    } else {
      loader = new CubeTextureLoader(loadingManager);
    }
    loader.setCrossOrigin(crossOrigin);
    return loader.load(urls, (cubeMap) => onLoad(cubeMap, true, urls));
  } else {
    const url = urls[0];
    let loader: any;
    const suffix = getSuffix(url);
    if (suffix == "exr") {
      loader = new EXRLoader(loadingManager);
    } else if (suffix == "hdr") {
      loader = new RGBELoader(loadingManager);
    } else if (isRGBM) {
      loader = new RGBMLoader(loadingManager);
    } else {
      loader = new TextureLoader(loadingManager);
    }
    loader.setCrossOrigin(crossOrigin);
    return loader.load(
      url,
      (texture) => onLoad(texture, false, url),
      undefined,
      (error) => {
        console.error("Error loading environment map:", error);
      },
    );
  }
};
